import { Reference, ReferenceData } from '@/store/plan/ReferenceData/ReferenceData';
import { CopyStatuses, ICopyStatuses } from '@/store/plan/CopyStatuses/CopyStatuses';
import { CurriculumDetail } from '@/store/plan/Detail/CurriculumDetail';
import { PlansCommonResponse } from '@/repository/manager/plans/types/PlansCommonResponse';
import { IDetail } from '@/store/plan/Detail/IDeteil';
import { AxiosResponse } from 'axios';
import { AxiosInstance } from 'axios';
import { CurriculumsRepository } from '@/model/repository/manager/childcare-document/plan/CurriculumsRepository';

export default (Repository: AxiosInstance) =>
    (resource: string): CurriculumsRepository => ({
        async getStatuses(year: string, use_db_replica: boolean): Promise<CopyStatuses> {
            return new Promise<CopyStatuses>((resolve, reject) => {
                Repository.get(`${resource}/statuses/decade/${year}`, { params: { use_db_replica } })
                    .then((res: AxiosResponse<PlansCommonResponse<ICopyStatuses>>) => {
                        resolve(new CopyStatuses(res.data.data));
                    })
                    .catch((error) => {
                        const status = error.response ? error.response.status : null;
                        reject({ error, status });
                    });
            });
        },

        async getContents(fiscalYear: string): Promise<ReferenceData> {
            return new Promise<ReferenceData>((resolve, reject) => {
                Repository.get(`${resource}/contents/${fiscalYear}`)
                    .then((res: AxiosResponse<PlansCommonResponse<Reference>>) => {
                        const referenceData = new ReferenceData(res.data.data.content, res.data.data.display_date);
                        resolve(referenceData);
                    })
                    .catch((error) => {
                        const status = error.response ? error.response.status : null;
                        reject({ error, status });
                    });
            });
        },

        async getDetail(fiscalYear: string, payload: { use_db_replica: boolean }): Promise<CurriculumDetail> {
            return new Promise<CurriculumDetail>((resolve, reject) => {
                Repository.get(`${resource}/fiscal-year/${fiscalYear}`, { params: payload })
                    .then((response: AxiosResponse<PlansCommonResponse<IDetail>>) => {
                        const res = response.data.data;
                        resolve(
                            new CurriculumDetail(
                                res.id,
                                res.kind,
                                res.title,
                                res.content,
                                res.display_date,
                                res.permission_id,
                                res.file_url,
                                res.update_datetime
                            )
                        );
                    })
                    .catch((error) => {
                        const status = error.response ? error.response.status : null;
                        reject({ error, status });
                    });
            });
        },
    });
